// @flow
import detailsItems from './detailsItems';
import detailsActivity from './detailsActivity';
import * as flags from './flags';


const filterId: 'details' = 'details';
export default filterId;
export { detailsItems, flags, detailsActivity };
